/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-01-05 10:30:50
 *
 *******************************************************/
//@flow
import React from 'react';
import { isNumeric } from 'src/helpers';

export const RenderRadioButtonItemV2 = (field: Object) => {
  return (
    <div>
      <label
        className="Polaris-Choice"
        htmlFor={field.id}
        style={{ flexDirection: 'column', width: '100%' }}>
        <span style={{ display: 'inline-flex', justifyContent: 'flex-start' }}>
          <span className="Polaris-Choice__Control">
            <span className="Polaris-RadioButton">
              <input
                id={field.id}
                className="Polaris-RadioButton__Input"
                name={field.input.name}
                type="radio"
                aria-describedby={`${field.id}HelpText`}
                checked={String(field.input.value) === String(field.id)}
                onChange={(e: any) => {
                  let value = e.target.value;
                  if (field.keepNumericValue && isNumeric(value)) {
                    value = Number(value);
                  }
                  field.input.onChange(value);
                }}
                value={field.value}
              />
              <span className="Polaris-RadioButton__Backdrop"></span>
            </span>
          </span>

          <span className="Polaris-Choice__Label">{field.label}</span>
        </span>

        {field?.helpText && (
          <div className="Polaris-Choice__Descriptions">
            <div id={`${field.id}HelpText`} className="Polaris-Choice__HelpText">
              {field?.helpText}
            </div>
          </div>
        )}
      </label>
    </div>
  );
};
